function definedProps(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined));
}
export function merge(obj1, obj2) {
  return {
    ...obj1,
    ...definedProps(obj2)
  };
}
export function round(number, decimals = 2) {
  return Math.round((number + Number.EPSILON) * 10 ** decimals) / 10 ** decimals;
}